import { ChatType } from '@anyx/common-graphql';

import { useCrmStore } from '../stores';

type ChatIntegrationPathMapKey = 'DEFAULT';
type ChatIntegrationPathMapValue = 'HOME' | 'SELECT' | ChatType;
type ChatIntegrationPathMap = Record<
  ChatIntegrationPathMapKey,
  Record<ChatIntegrationPathMapValue, string>
>;

/**
 * Getting chat integration path
 * reference from libs/function/account/src/lib/modules/brand/routing.tsx
 */
const useChatIntegrationPathMap = (): ChatIntegrationPathMap => {
  const storeId = useCrmStore((state) => state.storeId);

  return {
    DEFAULT: {
      HOME: `/${storeId}/store/integrations`,
      SELECT: `/${storeId}/store/integrations/chat`,
      INSTAGRAM: `/${storeId}/store/integrations/chat/instagram`,
      LINE: `/${storeId}/store/integrations/chat/line`,
      MESSENGER: `/${storeId}/store/integrations/chat/messenger`,
      WHATSAPP: `/${storeId}/store/integrations/chat/whatsapp`,
      LAZADA: `/${storeId}/store/integrations/chat/lazada`,
      SHOPEE: `/${storeId}/store/integrations/chat/shopee`,
      TIKTOK_SHOP: `/${storeId}/store/integrations/chat/tiktok-shop`,
    },
  };
};

export const useChatIntegrationPath = (chatType?: ChatIntegrationPathMapValue): string => {
  const { DEFAULT } = useChatIntegrationPathMap();

  return DEFAULT[chatType || 'SELECT'];
};
